import React from 'react';

import { useRouter } from 'next/router';

import TosPage, { PAGES, PageNames } from 'components/tos/TosPage';

const Tos = () => {
  const router = useRouter();
  const { pageName = 'tos' } = router?.query || {};

  if (Array.isArray(pageName) || !PAGES.includes(pageName as PageNames)) {
    // TODO: Make nice 404
    return <div>404</div>;
  }

  return <TosPage pageName={pageName as PageNames} />;
};

Tos.getInitialProps = async () => ({
  namespacesRequired: ['common', 'about', 'tos'],
});

export default Tos;
